import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import { Grid } from "@mui/material";
import React from "react";

const InTimeStatsSkeleton = () => {
	return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
				<Skeleton variant="rectangular" width={255.7} height={36.7} />
				<Skeleton variant="rectangular" width={234.4} height={39.5} />
				<Skeleton variant="rectangular" width={272} height={36.7} />
				<Skeleton variant="rectangular" width={70} height={35.8} />
			</Box>
            <Grid container rowSpacing={6} columnSpacing={6}>
				<Grid size={6}>
					<Skeleton variant="rectangular" height={296} />
				</Grid>
				<Grid size={6}>
					<Skeleton variant="rectangular" height={296} />
				</Grid>
				<Grid size={6}>
					<Skeleton variant="rectangular" height={296} />
				</Grid>
				<Grid size={6}>
					<Skeleton variant="rectangular" height={296} />
				</Grid>
			</Grid>
        </Box>
    );
};

export default InTimeStatsSkeleton;
